interface Params {productType: ProductType, categoryUrl: string, prodId: string, routes: any}
export const createProductUrl = ({productType, categoryUrl, prodId, routes}:Params) => {
    if (productType === 1) {
        return `${origin}${routes.configurator}/${prodId}`;
    } else if (productType === 98) {
        return `${origin}${categoryUrl}`;
    } else if (productType === 99) {
        return `${origin}${routes.creator}/${prodId}`;
    } else if (productType === 2) {
        return `${origin}${categoryUrl}/${prodId}`;
    }
};
